function loadScript(src, attrObject, {
    appendBeforeBody, appendToID, appendBeforeId, appendAfterId
}) {
    // eslint-disable-line no-param-reassign
    return new Promise(function (resolve, reject) {
        let shouldAppend = false;
        let el = document.querySelector('script[src="' + src + '"]');
        if (!el) {
            el = document.createElement('script');
            el.type = 'text/javascript';
            el.async = true;
            el.src = src;
            shouldAppend = true;

            if (Object.prototype.toString.call(attrObject) === '[object Object]') {
                Object.keys(attrObject).forEach((key) => {
                    el.setAttribute(key, attrObject[key]);
                });
            }
        } else if (el.hasAttribute('data-loaded')) {
            resolve(el);
            return;
        }

        el.addEventListener('error', reject);
        el.addEventListener('abort', reject);
        el.addEventListener('load', function loadScriptHandler() {
            el.setAttribute('data-loaded', true);
            resolve(el);
        });

        if (shouldAppend) {
            if (appendToID) {
                document.getElementById(appendToID).appendChild(el);
            } else if (appendBeforeId) {
                const sibling = document.getElementById(appendBeforeId);
                sibling.parentNode.insertBefore(el, sibling);
            } else if (appendAfterId) {
                const sibling = document.getElementById(appendAfterId);
                sibling.parentNode.insertBefore(el, sibling.nextSibling);
            } else if (appendBeforeBody) {
                document.head.appendChild(el);
            } else {
                document.body.appendChild(el);
            }
        }
    });
}

function unloadScript(src) {
    // eslint-disable-line no-param-reassign
    return new Promise(function (resolve, reject) {
        const el = document.querySelector('script[src*="' + src + '"]');

        if (!el) {
            reject();
            return;
        }

        el.remove();

        resolve();
    });
}

export { unloadScript, loadScript };

const plugin = {
    install(app) {
        app.config.globalProperties.$loadScript = loadScript;
        app.config.globalProperties.$unloadScript = unloadScript;
    }
};

export default plugin;
